import angular from 'angular';

import cmsGridDirective from '../../Grid/GridDirective';
import GridParamsConverter from '../../Grid/GridParamsConverter';
import UserResource from '../UserResource'
import gettext from 'angular-gettext';
import localStorageService from 'angular-local-storage';
import appConfig from '../../ConfigModule/ConfigModule'

let usersGridModule = angular.module('cms.users.grid', [cmsGridDirective, UserResource, gettext, localStorageService, appConfig, GridParamsConverter])
    .component('usersGrid', {
        template: require('./users-grid.html'),
        bindings: {
            initialParams: '<?',
            onParamsChange: '&?',
            onPageChange: '&?',
        },
        controller: function (UserResource, gettextCatalog, toastr, localStorageService, CONFIG, GridParamsConverter, $state) {
            /** @ngInject */

            let getColumnDefs = () => {
                return [
                    {
                        headerName: gettextCatalog.getString("Email"),
                        field: "email",
                        filter: "text",
                        filterParams: {filterOptions: ['contains']}
                    },
                    {
                        headerName: gettextCatalog.getString("First name"),
                        field: "firstName",
                        filterParams: {filterOptions: ['contains']}
                    },
                    {
                        headerName: gettextCatalog.getString("Last name"),
                        field: "lastName",
                        filterParams: {filterOptions: ['contains']}
                    },
                    {
                        headerName: gettextCatalog.getString("Actions"),
                        suppressFilter: true,
                        cellRenderer: function (params) {
                            let button = angular.element(`<button class="btn btn-xs btn-primary">
                                    <i class="ion-edit"></i> 
                                    ${gettextCatalog.getString('Edit')}
                                </button>`);

                            button.on('click', function () {
                                $state.go('usersEdit', {
                                    id: params.data.id,
                                    returnState: {
                                        name: 'users',
                                        params: angular.copy($state.params)
                                    }
                                })
                            });

                            return button[0]
                        }
                    }
                ];
            };

            this.options = {
                _gridStateId: 'user-grid-state',
                _columnDefsCallback: getColumnDefs,
            };

            this.initialFilterModel = {};
            let dataInitialized = false;


            const defaultParams = {
                fistName: undefined,
                lastName: undefined,
                email: undefined,
                order_by: undefined,
                order_direction: undefined
            };

            this.$onInit = () => {
                if(!this.initialParams) {
                    this.initialParams = angular.copy(defaultParams);
                }

                if(this.initialParams.order_by) {
                    this.initialSortModel = [
                        {colId: this.initialParams.order_by, sort: this.initialParams.order_direction || 'asc'}
                    ];
                }

                if(this.initialParams.page) {
                    this.initialPage = this.initialParams.page;
                }


                ['firstName', 'lastName', 'email'].forEach(field => {
                    if(this.initialParams[field])
                        this.initialFilterModel[field] = ({type: 'contains', filter: this.initialParams[field]});
                });

                ['date'].forEach(field => {
                    if(this.initialParams[field + 'After'] && this.initialParams[field + 'Before'])
                        this.initialFilterModel[field] = ({
                            type: 'inRange',
                            filterType: "date",
                            dateFrom: this.initialParams[field + 'After'],
                            dateTo: this.initialParams[field + 'Before'],
                        });
                });

                this.datasource = {
                    getRows: params => {
                        let queryParams = GridParamsConverter.getCmsApiParams(params);
                        let stateParams = Object.assign({}, defaultParams, queryParams);

                        if(this.onParamsChange)
                            this.onParamsChange({params: angular.copy(stateParams)});

                        delete stateParams.page;
                        $state.go('.', stateParams, {
                            location: 'replace'
                        });

                        let responseData = [];
                        UserResource.findAll(queryParams, response => {
                            responseData = response.data;
                            let lastRow = response.total_count;
                            params.successCallback(responseData, lastRow);

                            if(!dataInitialized && this.initialPage && this.initialPage !== this.options.api.paginationGetCurrentPage() + 1) {
                                dataInitialized = true;
                                this.options.api.paginationGoToPage(parseInt(this.initialPage) - 1);
                            }
                        });
                    }
                };
            };

            this._onPageChange = page => {
                if(!dataInitialized)
                    return;
                if(this.onPageChange)
                    this.onPageChange({$page: page});
            };
        }
    });

export default usersGridModule.name;




// WEBPACK FOOTER //
// ./src/cmsCore/UsersModules/UsersGrid/UsersGrid.js